/**
 * This enum contains the status of the countdown timer.
 *
 * @author Mc Ayrton Aragon
 */
export enum AsyncCountdownTimerStatusEnum {
  STOPPED = 'STOPPED',
  STARTED = 'STARTED',
}
